import { render, staticRenderFns } from "./DemoRangeSliderMinAndMax.vue?vue&type=template&id=0827fef8&"
import script from "./DemoRangeSliderMinAndMax.vue?vue&type=script&lang=js&"
export * from "./DemoRangeSliderMinAndMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRangeSlider,VTextField})
